import CurrentUser from 'auth/CurrentUser';
import JoinSignUpForm from './JoinSignUpForm.jsx';
import OrganizationProfile from 'entities/OrganizationProfile';
import React from 'react';
import { Roles } from 'user/UserConstants';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';

import './styles/JoinOrganizationFormPanel.scss';

const JoinOrganizationFormPanel = React.createClass({
  propTypes: {
    organization: React.PropTypes.instanceOf(OrganizationProfile).isRequired,
    defaultValues: React.PropTypes.object,
    role: React.PropTypes.oneOf([Roles.teacher, Roles.student, Roles.parent]).isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  transitionToGroups() {
    this.context.router.push('/classes?origin=subscribed');
  },

  updateUserOrganization() {
    const onUserUpdateSuccess = () => {
      ToastActions.showSuccessToast('School joined');
      this.context.router.push('/landing');
    };

    const updateData = {
      organization_id: this.props.organization.id,
      role: CurrentUser.getUser().getRole() || this.props.role,
    };

    UserActions
      .update(updateData)
      .then(onUserUpdateSuccess);
  },

  render() {
    return (
      <div className="JoinOrganizationFormPanel">
        <JoinSignUpForm
          defaultValues={this.props.defaultValues}
          onUserCreate={this.updateUserOrganization}
        />
      </div>
    );
  },
});

export default JoinOrganizationFormPanel;



// WEBPACK FOOTER //
// ./src/join/components/JoinOrganizationFormPanel.jsx